// src/components/infografia/modals/ImageSearchModal.jsx
import React, { useState, useEffect } from 'react';
import { FaSearch, FaTimes, FaSpinner, FaExternalLinkAlt } from 'react-icons/fa';
// import { searchImages } from '../../../helpers/infografia/imageSearchService';
// TODO: Habilitar cuando se configuren las API keys de Unsplash y Pexels
// Para habilitar:
// 1. Añadir REACT_APP_UNSPLASH_KEY y REACT_APP_PEXELS_KEY al .env
// 2. Descomentar el import de searchImages
// 3. Descomentar el código en handleSearch
import Swal from 'sweetalert2';

const ImageSearchModal = ({ isOpen, onClose, onSelectImage }) => {
    const [query, setQuery] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    useEffect(() => {
        if (isOpen) {
            // Búsqueda inicial popular
            handleSearch('nature');
        } else {
            // Limpiar al cerrar
            setImages([]);
            setQuery('');
            setSearchQuery('');
            setPage(1);
        }
    }, [isOpen]);

    const handleSearch = async (searchTerm = null, pageNum = 1) => {
        // TODO: Habilitar cuando se configuren las API keys
        Swal.fire({
            title: 'Funcionalidad en desarrollo',
            text: 'La búsqueda de imágenes estará disponible próximamente. Por ahora, puedes subir imágenes desde tu dispositivo.',
            icon: 'info'
        });
        return;

        /* COMENTADO TEMPORALMENTE - Habilitar cuando se configuren las API keys
        const term = searchTerm || searchQuery || query;
        if (!term.trim()) return;

        setLoading(true);
        try {
            const results = await searchImages(term, pageNum);
            
            if (pageNum === 1) {
                setImages(results);
            } else {
                setImages(prev => [...prev, ...results]);
            }
            
            setHasMore(results.length === 20); // Si hay menos de 20, no hay más páginas
            setPage(pageNum);
        } catch (error) {
            Swal.fire({
                title: 'Error',
                text: 'No se pudieron cargar las imágenes',
                icon: 'error'
            });
        } finally {
            setLoading(false);
        }
        */
    };

    const handleLoadMore = () => {
        handleSearch(null, page + 1);
    };

    const handleSelectImage = (image) => {
        onSelectImage(image.url);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-2xl w-full max-w-6xl max-h-[90vh] flex flex-col">
                {/* Header */}
                <div className="flex items-center justify-between p-6 border-b border-gray-200">
                    <h2 className="text-2xl font-semibold text-gray-900">Buscar Imágenes</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600"
                    >
                        <FaTimes className="text-2xl" />
                    </button>
                </div>

                {/* Search Bar */}
                <div className="p-6 border-b border-gray-200">
                    <div className="flex gap-2">
                        <div className="flex-1 relative">
                            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                            <input
                                type="text"
                                value={query}
                                onChange={(e) => setQuery(e.target.value)}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        setSearchQuery(query);
                                        handleSearch(query, 1);
                                    }
                                }}
                                placeholder="Buscar imágenes (ej: naturaleza, comida, tecnología...)"
                                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <button
                            onClick={() => {
                                setSearchQuery(query);
                                handleSearch(query, 1);
                            }}
                            disabled={loading || !query.trim()}
                            className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            Buscar
                        </button>
                    </div>
                </div>

                {/* Images Grid */}
                <div className="flex-1 overflow-y-auto p-6">
                    {loading && images.length === 0 ? (
                        <div className="flex items-center justify-center h-64">
                            <FaSpinner className="animate-spin text-4xl text-blue-500" />
                        </div>
                    ) : images.length === 0 ? (
                        <div className="text-center text-gray-500 py-12">
                            <p>No se encontraron imágenes</p>
                            <p className="text-sm mt-2">Intenta con otra búsqueda</p>
                        </div>
                    ) : (
                        <>
                            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                                {images.map((image) => (
                                    <div
                                        key={image.id}
                                        className="group relative cursor-pointer rounded-lg overflow-hidden border-2 border-gray-200 hover:border-blue-500 transition-all"
                                        onClick={() => handleSelectImage(image)}
                                    >
                                        <img
                                            src={image.thumb}
                                            alt={image.author}
                                            className="w-full h-48 object-cover"
                                            loading="lazy"
                                        />
                                        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-all flex items-center justify-center">
                                            <div className="opacity-0 group-hover:opacity-100 transition-opacity text-white text-center p-2">
                                                <p className="text-sm font-medium">{image.author}</p>
                                            </div>
                                        </div>
                                        <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100">
                                            <a
                                                href={image.authorUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                onClick={(e) => e.stopPropagation()}
                                                className="bg-white rounded-full p-2 hover:bg-gray-100"
                                                title="Ver autor"
                                            >
                                                <FaExternalLinkAlt className="text-xs text-gray-600" />
                                            </a>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Load More Button */}
                            {hasMore && (
                                <div className="mt-6 text-center">
                                    <button
                                        onClick={handleLoadMore}
                                        disabled={loading}
                                        className="px-6 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 disabled:opacity-50"
                                    >
                                        {loading ? (
                                            <span className="flex items-center gap-2">
                                                <FaSpinner className="animate-spin" />
                                                Cargando...
                                            </span>
                                        ) : (
                                            'Cargar más'
                                        )}
                                    </button>
                                </div>
                            )}
                        </>
                    )}
                </div>

                {/* Footer */}
                <div className="p-4 border-t border-gray-200 bg-gray-50 text-xs text-gray-500 text-center">
                    <p>Imágenes de Unsplash y Pexels - Gratis para uso comercial</p>
                </div>
            </div>
        </div>
    );
};

export default ImageSearchModal;

